// extracted by mini-css-extract-plugin
export default {"main":"order-button_main__MCfu9"};